export default "__VITE_ASSET__DJcgI4O8__"